export default __webpack_public_path__ + "static/media/arw_pulldown.cb196e08.svg";